<template>
  <div class="relative">
    <!-- Main Button -->
    <base-button icon type="primary" @click="toggleDropdown">
      <span class="btn-inner--icon"><i class="fas fa-sliders-h"></i></span>
      <span class="btn-inner--text">{{ translate("Maintenance") }}</span>
    </base-button>

    <!-- Dropdown Menu -->
    <div
      v-if="showDropdown"
      class="absolute -right-1/2 mt-2 w-96 bg-white rounded-lg shadow-xl z-50 dropdown-wrapper"
    >
      <!-- Dropdown Header -->
      <div
        class="px-4 py-3 border-b border-gray-200 flex justify-between items-center"
      >
        <h3 class="text-lg font-medium text-gray-800 mb-0">
          {{ translate("Kiosk Maintenance Controls") }}
        </h3>
        <button
          class="border-none bg-transparent focus:outline-none"
          @click="toggleDropdown"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Dropdown Content -->
      <div class="p-3 dropdown-content">
        <!-- Turn ON Maintenance Button -->
        <button
          @click="openTurnOnModal"
          class="w-full mb-3 ml-0 mt-0 py-2 px-4 flex items-center justify-center rounded-md bg-red-500 hover:bg-red-600 text-white font-medium transition duration-200 border-transparent focus:outline-none"
        >
          <i class="fas fa-power-off mx-2"></i>
          {{ translate("Turn ON Maintenance Mode for All") }}
        </button>

        <!-- Turn OFF Maintenance Button -->
        <button
          @click="openTurnOffModal"
          class="w-full py-2 px-4 flex items-center justify-center rounded-md bg-green-500 hover:bg-green-600 text-white font-medium transition duration-200 border-transparent"
        >
          <i class="fas fa-power-off mx-2"></i>
          {{ translate("Turn OFF Maintenance Mode for All") }}
        </button>
      </div>
    </div>
    <!-- Maintenance Modal -->
    <maintenance-modal
      v-if="showTurnOnModal"
      :active="true"
      @close="showTurnOnModal = false"
      @confirm="confirmTurnOnMaintenance"
    />

    <!-- Maintenance Modal -->
    <maintenance-modal
      v-if="showTurnOffModal"
      @close="showTurnOffModal = false"
      @confirm="confirmTurnOffMaintenance"
    />
  </div>
</template>

<script>
import { translations } from "@/mixins";
import MaintenanceModal from "./MaintenanceModal.vue";
import { Device } from "@/services/SOLO";

export default {
  name: "MaintenanceActionButton",
  components: {
    MaintenanceModal,
  },

  data() {
    return {
      showDropdown: false,
      showTurnOnModal: false,
      showTurnOffModal: false,
    };
  },

  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },

    openTurnOnModal() {
      this.showDropdown = false;
      this.showTurnOnModal = true;
    },

    openTurnOffModal() {
      this.showDropdown = false;
      this.showTurnOffModal = true;
    },

    async confirmTurnOnMaintenance() {
      try {
        await Device.enableMaintenanceMode();
        this.$emit("fetchDevices");
        this.$notify({
          title: this.translate("Maintenance Mode Turned On."),
          verticalAlign: "bottom",
          horizontalAlign: "right",
          message: this.translate(
            "All Devices has been successfully placed in maintenance mode."
          ),
          type: "success",
          icon: "fas fa-check",
        });
      } catch (error) {
        console.error("Error enabling maintenance mode:", error);
      }
      this.showTurnOnModal = false;
    },

    async confirmTurnOffMaintenance() {
      try {
        await Device.disableMaintenanceMode();
        this.$emit("fetchDevices");
        this.$notify({
          title: this.translate("Maintenance Mode Turned Off."),
          verticalAlign: "bottom",
          horizontalAlign: "right",
          message: this.translate(
            "All kiosks are now back to normal operation successfully."
          ),
          type: "success",
          icon: "fas fa-check",
        });
      } catch (error) {
        console.error("Error disabling maintenance mode:", error);
      }
      this.showTurnOffModal = false;
    },
  },

  mixins: [translations],
};
</script>

<style scoped>
.dropdown-wrapper {
  border: 0.5px solid #e5e7eb;
}
.dropdown-content {
  border-top: 1px solid #e5e7eb;
}
</style>
